<div [formGroup]="customerForm" class="formgrid grid overflow-visible">
  <div class="col-6 field flex flex-column">
    <label for="customerCRM">Select CRM</label>
    <p-select
      [options]="CRMOptions"
      formControlName="crmType"
      inputId="customerCRM"
      size="small"
      styleClass=" w-full"
    ></p-select>
  </div>
  <div class="col-6 field flex flex-column">
    <label for="CRMID">CRM Org ID</label>
    <input
      formControlName="internalCrmId"
      id="CRMID"
      pInputText
      pSize="small"
      type="text"
    />
  </div>
  <div class="col-6 field flex flex-column">
    <label for="customerName">Customer Name</label>
    <input
      formControlName="name"
      id="customerName"
      pInputText
      pSize="small"
      type="text"
    />
  </div>
  <div class="col-6 field flex flex-column">
    <label for="customerDomain">Customer Domain</label>
    <input
      formControlName="domain"
      id="customerDomain"
      pInputText
      pSize="small"
      type="text"
    />
  </div>
  <div class="col-6 field flex flex-column">
    <label for="customerEmail">Primary Contact Email</label>
    <input
      formControlName="contactEmail"
      id="customerEmail"
      pInputText
      pSize="small"
      type="email"
    />
  </div>
  <div class="col-6 field flex flex-column">
    <label for="accountOwner">DemandScience Account Owner</label>
    <input
      formControlName="owner"
      id="accountOwner"
      pInputText
      pSize="small"
      type="text"
    />
  </div>
  @if (isEdit) {
  <div class="col-6 field flex flex-column">
    <label for="customerStatus">Customer Status</label>
    <p-select
      size="small"
      styleClass=" w-full z-5"
      inputId="customerStatus"
      formControlName="status"
      [options]="StatusOptions"
    ></p-select>
  </div>
  }
</div>
<div class="flex justify-content-end gap-2">
  <p-button (onClick)="cancel()" [outlined]="true" label="Cancel" />
  <p-button
    (onClick)="isEdit ? editCustomer() : provisionCustomer()"
    [label]="isEdit ? 'Save Changes' : 'Create Customer'"
  />
</div>
